import type { Author, ContractedBook } from '@/data/types';

export const KONKURRENT_BY_SJANSE = 0.12;
export const KONKURRENT_BY_MIN_FAKTOR = 1.1;
export const KONKURRENT_BY_MAX_FAKTOR = 1.5;

export const STJELE_FORSOEK_SJANSE = 0.02;
export const STJELE_MIN_FORFATTERE = 3;
export const STJELE_COOLDOWN_DAGER = 10;
export const STJELE_EVENT_PREFIKS = 'synth_stjeleforsoek_';

export type StjeleKontekst = {
  type: 'stjeleforsoek';
  konkurrentId: string;
  forfatterId: string;
  beloep: number;
};

export function byggStjeleEventId(forfatterId: string, dag: number): string {
  return `${STJELE_EVENT_PREFIKS}${forfatterId}_${dag}`;
}

export function erStjeleEventId(eventId: string): boolean {
  return eventId.startsWith(STJELE_EVENT_PREFIKS);
}

export function erStjelbarForfatter(
  forfatter: Author,
  alleBoker: ReadonlyArray<ContractedBook>,
): boolean {
  if (forfatter.paaKurs) return false;
  for (const b of alleBoker) {
    if (b.authorId === forfatter.id) return true;
  }
  return false;
}
